import { GetInterestsByCategoryIdMeta, GetInterestsByCategoryIdPayload } from 'types/store/GetInterestsByCategoryId';
import { createAsyncReducer } from 'utils/Redux';

import { getInterestsByCategoryIdActions } from '../actions';

export default createAsyncReducer<GetInterestsByCategoryIdMeta, GetInterestsByCategoryIdPayload>(getInterestsByCategoryIdActions);
